// The one mark for AI output across the Messages inbox; callers set its size and colour.
export function AiGlyph({ className = '' }: { className?: string }) {
    return (
        <span aria-hidden="true" className={`leading-none ${className}`}>
            ✦
        </span>
    );
}
